import { FrequentPassageRequest } from '@legacy-types';

import { api } from '@shared/api/api';

type ParkingRequestParkingSticker = App.Domain.Parking.Data.ParkingRequestParkingStickerData;

export type HandOutParkingRequestParkingSticker = {
  code: number;
  claimingCrewMemberId: number;
};

export function handOutParkingSticker(
  eventId: number,
  parkingRequestParkingStickerId: number,
  data: HandOutParkingRequestParkingSticker
) {
  return api.post<ParkingRequestParkingSticker>(
    `events/${eventId}/parking-request-parking-stickers/${parkingRequestParkingStickerId}/claim`,
    data
  );
}
